// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__0QVME","socialMedia":"Footer_socialMedia__ec0uI","socialIcon":"Footer_socialIcon__bs1Fw","socialImage":"Footer_socialImage__T8h1h"};